export const translations = {
  ka: {
    header: {
      stations: "პროდუქტები",
      platform: "პლატფორმა",
      pricing: "ფასები",
      contact: "კონტაქტი",
      logIn: "შესვლა",
      getStarted: "დაწყება",
      dashboard: "მართვის პანელი",
      signOut: "გასვლა",
      wallet: "საფულე",
    },
    hero: {
      badge: "რესტორნებისთვის, კაფეებისთვის და სასტუმროებისთვის",
      headline: "ლოიალობა და შეკვეთები.\nერთი პანელი.",
      subtitle:
        "KIDE ლოიალობის პროგრამა და MNU.QR ციფრული მენიუ — ერთი პლატფორმიდან. აპლიკაცია არ სჭირდება.",
      bookDemo: "დემოს დაჯავშნა",
      seeHow: "როგორ მუშაობს →",
    },
    businesses: {
      title: "ჩვენი პარტნიორები",
      subtitle: "აღმოაჩინეთ ბიზნესები, რომლებიც FlowState-ს იყენებენ",
      all: "ყველა",
      coffee: "ყავა",
      food: "საკვები",
      retail: "საცალო",
      wellness: "ველნესი",
      services: "სერვისები",
      noBranches: "ფილიალები არ არის",
      noBusinesses: "ბიზნესები ჯერ არ არის",
      branches: "ფილიალი",
      rating: "რეიტინგი",
    },
    preview: {
      yourDashboard: "თქვენი პანელი",
      live: "პირდაპირ",
      newOrder: "ახალი შეკვეთა — მაგიდა 4",
      placed: "მოლოდინში",
      margherita: "2x მარგარიტა პიცა",
      caesar: "1x ცეზარის სალათი",
      noAnchovies: "გარეშე: ანჩოუსი",
      accept: "მიღება",
      reject: "უარყოფა",
      stampGranted: "ბეჭედი მინიჭებულია",
      stampInfo: "მარიამ ს. — 7/10 ბეჭედი",
      justNow: "ახლახანს",
      cafeName: "კაფე მილანო",
      table4: "მაგიდა 4",
      menu: "მენიუ",
      margheritaName: "მარგარიტა პიცა",
      vegetarian: "ვეგეტარიანული",
      caesarName: "ცეზარის სალათი",
      glutenFree: "გლუტენის გარეშე",
      yourOrder: "თქვენი შეკვეთა",
      preparing: "თქვენი შეკვეთა მზადდება...",
      callServer: "მიმტანი",
      requestBill: "ანგარიში",
      min15: "15 წთ",
      min10: "10 წთ",
    },
    stations: {
      label: "// 001 — პროდუქტები",
      headline: "ორი პროდუქტი.\nყველაფერი რაც გჭირდებათ.",
      subtitle:
        "გამოიყენეთ ერთი ან ორივე. თითოეული მუშაობს დამოუკიდებლად და ერთიანდება საერთო პანელში.",
      kideSubtitle: "ლოიალობა და შენარჩუნება",
      mnuqrSubtitle: "ციფრული მენიუ და შეკვეთები",
      kide: {
        scanner: {
          title: "QR ლოიალობის სკანერი",
          desc: "სკანირება კამერით ან 6-ნიშნა კოდით. ბეჭდების მინიჭება, ისტორია და დაშვების წესები.",
        },
        programs: {
          title: "პროგრამები და ჯილდოები",
          desc: "ბეჭდებზე დაფუძნებული ლოიალობა კონფიგურირებადი ზღვრებით. ჯილდოები ქულების ღირებულებით.",
        },
        analytics: {
          title: "წევრები და ანალიტიკა",
          desc: "ავტომატური რეგისტრაცია QR ID-ებით. შენარჩუნების მეტრიკა და CSV ექსპორტი.",
        },
      },
      mnuqr: {
        builder: {
          title: "მენიუს რედაქტორი",
          desc: "კატეგორიები, კერძები, ფასები, სურათები, დიეტური ტეგები და ინგრედიენტების მართვა.",
        },
        orders: {
          title: "შეკვეთების მართვა",
          desc: "სრული ციკლი — მოლოდინში, მზადდება, მზადაა, მირთმეულია. მიღება, უარყოფა და ქვითარი.",
        },
        selfOrder: {
          title: "სტუმრის თვითმომსახურება",
          desc: "QR სკანირება, მენიუს დათვალიერება, ინგრედიენტების არჩევა და შეკვეთა ტელეფონიდან. აპი არ სჭირდება.",
        },
      },
    },
    features: {
      label: "// 002 — პლატფორმა",
      headline: "ერთი პანელი. სრული კონტროლი.",
      subtitle:
        "ორივე პროდუქტი ერთიან პლატფორმაზეა — რეალურ დროში სინქრონიზაცია, როლებზე დაფუძნებული უფლებები და ერთი ხედი.",
      dashboard: {
        title: "ერთიანი პანელი",
        desc: "ლოიალობა და მენიუს შეკვეთები ერთი ეკრანიდან. გადართეთ პროდუქტებს შორის ან გამოიყენეთ გაყოფილი ხედი.",
      },
      realtime: {
        title: "რეალურ დროში ყველაფერი",
        desc: "შეკვეთები, ლოიალობის ბეჭდები, მენიუს ცვლილებები და შეტყობინებები მყისიერად სინქრონიზდება. თქვენი პერსონალი და სტუმრები ყოველთვის ხედავენ უახლეს მონაცემებს.",
      },
      security: {
        title: "უსაფრთხო და როლებზე დაფუძნებული",
        desc: "როლებზე დაფუძნებული წვდომა თქვენი გუნდისთვის, API გასაღებები ინტეგრაციებისთვის და აუდიტის ჟურნალი ყველა მოქმედებისთვის.",
      },
    },
    howItWorks: {
      label: "// 003 — როგორ მუშაობს",
      headline: "სამი ნაბიჯი გაშვებამდე",
      step1: {
        title: "წვდომის მოთხოვნა",
        desc: "მოგვიყევით თქვენი ბიზნესის შესახებ და აირჩიეთ — KIDE, MNU.QR ან ორივე.",
      },
      step2: {
        title: "ჩვენ გავაწყობთ",
        desc: "ჩვენი გუნდი გააწყობს პანელს, შემოიტანს მენიუს ან ლოიალობის კონფიგურაციას და შექმნის QR კოდებს.",
      },
      step3: {
        title: "გაშვება",
        desc: "დაიწყეთ და თვალყური ადევნეთ შეკვეთებს, ლოიალობას და ანალიტიკას რეალურ დროში.",
      },
      requestAccess: "წვდომის მოთხოვნა",
    },
    wallet: {
      title: "თქვენი ლოიალობის ბარათები",
      subtitle: "ნახეთ ბეჭდების პროგრესი, კუპონები და ჯილდოები ერთ ვირტუალურ საფულეში.",
      goToDashboard: "მართვის პანელი",
      cards: "ბარათები",
      cardsCount: "{count} აქტიური ბარათი",
      loadingCards: "ბარათები იტვირთება...",
      noCards: "ჯერ არც ერთი საგულე ბარათი არ გაქვთ.",
      noCardsHint: "ჰკითხეთ ობიექტს FlowState ლოიალობის პროგრამაზე და დარეგისტრირდით მათთან.",
      stampsLabel: "{current}/{required} ბეჭედი",
      tapToOpen: "ბარათის გახსნა დეტალებისთვის",
      history: "ჯილდოების ისტორია",
      historyCount: "{count} ჩანაწერი",
      loadingHistory: "ისტორია იტვირთება...",
      noHistoryYet: "ჯერ არც ერთი ჯილდო არ გიგივილიათ.",
      noDataYet: "საფულე ჯერ ცარიელია. დააგროვეთ ბეჭდები პირველი ჯილდოსთვის.",
      noHistoryHint: "როდესაც ჯილდოს მიიღებთ, კოდი და სტატუსი აქ გამოჩნდება.",
      codeLabel: "კოდი:",
      statusRedeemed: "გამოყენებული",
      statusPending: "მოლოდინში",
      statusExpired: "ვადაგასული",
      backToDashboard: "დაბრუნება მართვის პანელზე",
      rewardAvailable: "ჯილდო ხელმისაწვდომია",
      loadingCard: "ბარათი იტვირთება...",
      cardStamps: "{current}/{required} ბეჭედი ამ პროგრამაში",
      presentAtCounter: "აჩვენეთ ეს QR ან კოდი ობიექტის პერსონალს",
      expiresIn: "ვადაგასვლამდე {seconds} წმ",
      generatingCode: "კოდი გენერირდება...",
      generateCode: "კოდის გენერაცია",
      refreshCode: "კოდის განახლება",
      orShareCode: "ან უთხარით 6-ნიშნა კოდი",
      back: "დაბრუნება საფულეში",
      rewards: "ჯილდოები",
      noRewardsConfigured: "ამ ობიექტმა ჯერ არ დაამატა ჯილდოები.",
      claimReward: "ჯილდოს მიღება",
      notEnoughStamps: "არასაკმარისი ბეჭდები",
      claimSuccess: "\"{reward}\" ჯილდო გააქტიურდა.",
      showCode: "აჩვენეთ ეს კოდი ობიექტის სისტემაში დასამოწმებლად.",
      pendingRewards: "გამოუყენებელი ჯილდოები",
      pendingRewardsHint: "ეს ჯილდოები ჯერ არ არის გამოყენებული. აჩვენეთ კოდი ობიექტის პერსონალს.",
      pendingStatus: "მოლოდინში — ჯერ არ გამოყენებულა",
      viewCode: "კოდის ნახვა",
      hideCode: "კოდის დამალვა",
      tapToViewReward: "შეეხეთ ჯილდოს კოდის სანახავად →",
      cancelCard: "ბარათის გაუქმება",
      cancelCardConfirmTitle: "ნამდვილად გსურთ ბარათის გაუქმება?",
      cancelCardConfirmDesc: "ყველა ბეჭედი და პროგრესი წაიშლება. ეს მოქმედება შეუქცევადია.",
      cancelCardNo: "არა",
      cancelCardYes: "გაუქმება",
    },
    why: {
      label: "// 004 — რატომ FlowState",
      headline: "შექმნილია განსხვავებულად. მიზანმიმართულად.",
      reasons: {
        vendors: {
          title: "ერთი პლატფორმა ბევრის ნაცვლად",
          desc: "ლოიალობა, მენიუ, შეკვეთები, QR კოდები და ანალიტიკა — ცალკეული ხელსაწყოების ნაცვლად.",
        },
        noApp: {
          title: "აპლიკაცია არ სჭირდება",
          desc: "სტუმრები სკანერებენ QR კოდს და მზად არიან — ბრაუზერიდან.",
        },
        hospitality: {
          title: "სტუმართმოყვარეობისთვის შექმნილი",
          desc: "ყველა ფუნქცია შექმნილია რესტორნებისთვის, კაფეებისთვის და სასტუმროებისთვის.",
        },
        fast: {
          title: "გაშვება დღეებში",
          desc: "ჩვენ ვმართავთ კონფიგურაციას. თქვენი ბიზნესი გაეშვება მინიმალური ძალისხმევით.",
        },
      },
    },
    pricing: {
      label: "// 005 — ფასები",
      headline: "მარტივი, გამჭვირვალე ფასები",
      subtitle:
        "ყველა გეგმა მოიცავს გაწყობას, ონბორდინგს და მხარდაჭერას. გამოიყენეთ ერთი პროდუქტი ან ორივე.",
      monthly: "თვიური",
      yearly: "წლიური",
      save20: "დაზოგე 20%",
      perMonth: "/თვე",
      billedAnnually: "გადახდა წლიურად",
      bestValue: "საუკეთესო ფასი",
      contactSales: "გაყიდვები",
      kide: {
        desc: "ლოიალობის პროდუქტი",
        features: [
          "შეუზღუდავი ლოიალობის პროგრამები",
          "QR სკანერი + კოდის ხელით შეყვანა",
          "კონფიგურირებადი ბეჭდები და ჯილდოები",
          "წევრების მართვა და ანალიტიკა",
          "ბიზნეს პროფილი და მრავალ ფილიალი",
          "CSV ექსპორტი და API წვდომა",
        ],
      },
      mnuqr: {
        desc: "ციფრული მენიუს და შეკვეთების პროდუქტი",
        features: [
          "მენიუს რედაქტორი დიეტური ტეგებით",
          "შეკვეთების მართვა რეალურ დროში",
          "მაგიდის QR კოდები (ბეჭდვა და ჩამოტვირთვა)",
          "სტუმრის თვითმომსახურება (აპი არ სჭირდება)",
          "მიმტანის და ანგარიშის შეტყობინებები",
          "შემოსავლის ანალიტიკა და CSV ექსპორტი",
        ],
      },
      fullSuite: {
        name: "სრული პაკეტი",
        desc: "ორივე პროდუქტი + პრიორიტეტული მხარდაჭერა",
        features: [
          "ყველაფერი KIDE + MNU.QR-დან",
          "ერთიანი პანელი გაყოფილი ხედით",
          "პირადი ანგარიშის მენეჯერი",
          "პრიორიტეტული მხარდაჭერა",
          "ინდივიდუალური ინტეგრაციები",
          "ადრეული წვდომა ახალ ფუნქციებზე",
        ],
      },
      cta: {
        headline: "მზად ხართ დასაწყებად?",
        subtitle:
          "დაჯავშნეთ დემო და ჩვენ გაჩვენებთ ზუსტად როგორ მუშაობს FlowState თქვენი ობიექტისთვის.",
        bookDemo: "დემოს დაჯავშნა",
        requestAccess: "წვდომის მოთხოვნა →",
      },
    },
    footer: {
      desc: "ლოიალობის პროგრამები, ციფრული მენიუ, შეკვეთები რეალურ დროში და ანალიტიკა — ერთი პლატფორმიდან.",
      stations: "პროდუქტები",
      kideLoyalty: "KIDE — ლოიალობა",
      mnuqrMenus: "MNU.QR — მენიუ",
      fullSuite: "სრული პაკეტი",
      pricingLink: "ფასები",
      platformCol: "პლატფორმა",
      commandStation: "პანელი",
      howItWorks: "როგორ მუშაობს",
      requestAccess: "წვდომის მოთხოვნა",
      bookDemo: "დემოს დაჯავშნა",
      company: "კომპანია",
      contactSales: "გაყიდვებთან დაკავშირება",
      aboutUs: "ჩვენ შესახებ",
      careers: "კარიერა",
      blog: "ბლოგი",
      rights: "© 2026 FlowState. ყველა უფლება დაცულია.",
      privacy: "კონფიდენციალურობა",
      terms: "პირობები",
      security: "უსაფრთხოება",
    },
    login: {
      commandCenter: "თქვენი ბიზნესის\nმართვის ცენტრი",
      subtitle: "ლოიალობის პროგრამები, ციფრული მენიუ და ოპერაციების მართვა — ყველაფერი ერთი პლატფორმიდან.",
      signIn: "შესვლა",
      welcome: "კეთილი იყოს თქვენი მობრძანება. შეიყვანეთ მონაცემები გასაგრძელებლად.",
      email: "ელ-ფოსტა",
      password: "პაროლი",
      pleaseWait: "გთხოვთ დაელოდოთ...",
      invalidCredentials: "არასწორი ელ-ფოსტა ან პაროლი.",
      timedOut: "შესვლის ვადა ამოიწურა. სცადეთ ხელახლა.",
      wantPartner: "გსურთ პარტნიორი გახდეთ?",
      requestAccessDesc: "მოითხოვეთ წვდომა და ჩვენი გუნდი გაგიწყობთ",
      requestPartnerAccess: "პარტნიორის წვდომის მოთხოვნა",
      accountSuspended: "ანგარიში შეჩერებულია",
      suspendedMsg: "თქვენი ანგარიში შეჩერებულია. დაუკავშირდით ადმინისტრატორს დამატებითი ინფორმაციისთვის.",
      backToSignIn: "შესვლაზე დაბრუნება",
    },
    requestAccess: {
      headline: "შეუერთდით\nწამყვან ბიზნესებს",
      subtitle: "მოითხოვეთ პარტნიორის წვდომა FlowState-ის მოდულარული პლატფორმის გამოსაყენებლად — ლოიალობა, მენიუ და ოპერაციები, ჩვენი გუნდის მიერ მართული.",
      title: "წვდომის მოთხოვნა",
      plan: "გეგმა",
      formSubtitle: "შეავსეთ მონაცემები და ჩვენი გუნდი დაგიკავშირდებათ 48 საათის განმავლობაში.",
      fullName: "სრული სახელი",
      workEmail: "სამუშაო ელ-ფოსტა",
      companyName: "კომპანიის სახელი",
      yourRole: "თქვენი როლი",
      contactNumber: "საკონტაქტო ნომერი",
      tellUs: "მოგვიყევით თქვენი საჭიროებების შესახებ",
      tellUsPlaceholder: "რომელი პროდუქტებით ხართ დაინტერესებული? რაიმე სპეციფიკური მოთხოვნა?",
      submitting: "იგზავნება...",
      submitRequest: "მოთხოვნის გაგზავნა",
      alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
      signInLink: "შესვლა",
      submitted: "მოთხოვნა გაგზავნილია",
      submittedMsg: "ჩვენ განვიხილავთ თქვენს მოთხოვნას და დაგიკავშირდებით 48 საათის განმავლობაში.",
      backHome: "მთავარზე დაბრუნება",
      avgResponse: "საშ. პასუხი",
      onboarding: "ონბორდინგი",
      free: "უფასო",
      support: "მხარდაჭერა",
    },
    contactSales: {
      backHome: "← მთავარზე დაბრუნება",
      headline: "გაყიდვებთან დაკავშირება",
      subtitle: "ესაუბრეთ ჩვენს გაყიდვების გუნდს სრული პაკეტის და თქვენს ბიზნესზე მორგებული ინტეგრაციების შესახებ.",
      yourName: "თქვენი სახელი",
      workEmail: "სამუშაო ელ-ფოსტა",
      companyName: "კომპანიის სახელი",
      tellUs: "მოგვიყევით თქვენი საჭიროებების შესახებ...",
      sendMessage: "შეტყობინების გაგზავნა",
    },
    dash: {
      splitView: "გაყოფილი ხედი",
      exitSplit: "გაყოფილი ხედიდან გასვლა",
      noActiveServices: "აქტიური სერვისები არ არის",
      noServicesMsg: "აქტიური სერვისები ხელმისაწვდომი არ არის. დაუკავშირდით ადმინისტრატორს.",
      noServices: "სერვისები არ არის",
      kideNav: {
        scanStamps: "ბეჭდების სკანირება",
        businessInfo: "ბიზნეს ინფო",
        loyalty: "ლოიალობის პროგრამა",
        users: "მომხმარებლები",
        analytics: "ანალიტიკა",
        settings: "პარამეტრები",
      },
      mnuqrNav: {
        ringServer: "სერვერის გამოძახება",
        orders: "შეკვეთები",
        editMenus: "მენიუს რედაქტირება",
        qrCodes: "QR კოდები",
        menuAnalytics: "მენიუს ანალიტიკა",
        settings: "პარამეტრები",
        businessInfo: "ბიზნეს ინფო",
      },
      kideLabel: "KIDE",
      mnuqrLabel: "MNU.QR",
    },
    kideTab: {
      scanStamps: {
        title: "ბეჭდების სკანირება",
        desc: "დაასკანერეთ მომხმარებლის QR კოდები ლოიალობის ბეჭდების მინიჭებისთვის",
        scanner: "სკანერი",
        cameraUnavailable: "კამერა მიუწვდომელია",
        retry: "ხელახლა",
        enterCode: "ან შეიყვანეთ კოდი",
        grant: "მინიჭება",
        stampsGranted: "ბეჭდები მინიჭებული",
        errors: "შეცდომები",
        totalScans: "სულ სკანირებები",
        lastScan: "ბოლო სკანირება",
        latestActivity: "ბოლო აქტივობა",
        clear: "წაშლა",
        status: "სტატუსი",
        details: "დეტალები",
        time: "დრო",
        noScansYet: "სკანირებები ჯერ არ არის. მიაშვირეთ კამერა QR კოდზე ან შეიყვანეთ კოდი ზემოთ.",
        cooldown: "დაშვების ინტერვალი",
        minRemaining: "წთ დარჩენილი",
        failedGrant: "ბეჭდის მინიჭება ვერ მოხერხდა",
        codeExpired: "კოდს ვადა გაუვიდა",
        codeAlreadyUsed: "კოდი უკვე გამოყენებულია",
        wrongPartner: "კოდი სხვა პარტნიორს ეკუთვნის",
        codeNotFound: "კოდი ვერ მოიძებნა",
        stampGrantedPopup: "ბეჭედი მინიჭებულია",
        rewardRedeemedPopup: "ჯილდო გამოსყიდულია",
        userNotFound: "მომხმარებელი ვერ მოიძებნა კოდით",
        stamps: "ბეჭდები",
        untilReward: "ჯილდომდე",
      },
      businessInfo: {
        title: "ბიზნეს ინფო",
        desc: "მართეთ თქვენი ბიზნეს პროფილი, რომელიც მომხმარებლებს ეჩვენებათ",
        loading: "ბიზნეს ინფო იტვირთება...",
        saved: "შენახულია",
        saving: "ინახება...",
        saveChanges: "ცვლილებების შენახვა",
        failedSave: "შენახვა ვერ მოხერხდა. სცადეთ ხელახლა.",
        basicInfo: "ძირითადი ინფორმაცია",
        businessName: "ბიზნესის სახელი",
        businessNamePlaceholder: "შეიყვანეთ ბიზნესის სახელი",
        googleRating: "Google რეიტინგი",
        googleRatingPlaceholder: "0 - 5",
        coverImagePlaceholder: "https://example.com/image.jpg",
        phonePlaceholder: "+1 234 567 890",
        websitePlaceholder: "https://example.com",
        about: "შესახებ",
        aboutPlaceholder: "მოუყევით მომხმარებლებს თქვენი ბიზნესის შესახებ",
        coverImage: "გარეკანის სურათის URL",
        phone: "ტელეფონის ნომერი",
        website: "ვებ-გვერდის URL",
        branches: "ფილიალების მდებარეობები",
        addBranch: "ფილიალის დამატება",
        noBranches: "ფილიალები ჯერ არ არის დამატებული. დააწკაპუნეთ „ფილიალის დამატება“ დასამატებლად.",
        branch: "ფილიალი",
        addressLabel: "მისამართის ეტიკეტი",
        latitude: "განედი",
        longitude: "გრძედი",
        openingHours: "სამუშაო საათები",
        to: "-დან",
        closed: "დაკეტილია",
        monday: "ორშაბათი",
        tuesday: "სამშაბათი",
        wednesday: "ოთხშაბათი",
        thursday: "ხუთშაბათი",
        friday: "პარასკევი",
        saturday: "შაბათი",
        sunday: "კვირა",
        category: "კატეგორია",
        selectCategory: "აირჩიეთ კატეგორია",
        cat_coffee: "ყავა",
        cat_food: "საკვები",
        cat_retail: "საცალო",
        cat_wellness: "ველნესი",
        cat_services: "სერვისები",
        clickMapToAdd: "დააწკაპუნეთ რუკაზე ფილიალის დასამატებლად",
      },
      loyalty: {
        title: "ლოიალობის პროგრამები",
        desc: "მართეთ, შეცვალეთ და თვალყური ადევნეთ ლოიალობის პროგრამებს",
        search: "ძებნა",
        newProgram: "ახალი პროგრამა",
        members: "წევრები",
        rewards: "ჯილდოები",
        conversion: "კონვერსია",
        loading: "იტვირთება...",
        noPrograms: "ლოიალობის პროგრამები ჯერ არ არის. შექმენით პირველი.",
        programStats: "პროგრამის სტატისტიკა",
        totalMembers: "სულ წევრები",
        rewardsGiven: "მინიჭებული ჯილდოები",
        conversionRate: "კონვერსიის მაჩვენებელი",
        status: "სტატუსი",
        editProgram: "პროგრამის რედაქტირება",
        maxUsers: "მაქს. მომხმარებლები",
        unlimited: "შეუზღუდავი",
        leaveEmpty: "დატოვეთ ცარიელი შეუზღუდავისთვის",
        stampsRequired: "საჭირო ბეჭდები",
        stampsMin: "ბეჭდები მინიმუმ 1 უნდა იყოს",
        scanCooldown: "სკანირების ინტერვალი (წთ)",
        cooldownRange: "ინტერვალი 1-დან 1440 წუთამდე უნდა იყოს",
        saving: "ინახება...",
        saveChanges: "ცვლილებების შენახვა",
        changesSaved: "ცვლილებები შენახულია",
        programName: "პროგრამის სახელი",
        reward: "ჯილდო",
        rewardPlaceholder: "მაგ. უფასო ყავა",
        rewardRequired: "ჯილდო აუცილებელია",
        new: "ახალი",
        active: "აქტიური",
        popular: "პოპულარული",
        paused: "შეჩერებული",
        createProgram: "პროგრამის შექმნა",
      },
      users: {
        title: "მომხმარებლები",
        desc: "იხილეთ ლოიალობის პროგრამის ჩარიცხული წევრები",
        search: "მომხმარებლების ძებნა",
        allUsers: "ყველა მომხმარებელი",
        total: "სულ",
        name: "სახელი",
        email: "ელ-ფოსტა",
        stamps: "ბეჭდები",
        enrolled: "ჩარიცხულია",
        loading: "იტვირთება...",
        noUsers: "მომხმარებლები ჯერ არ არის ჩარიცხული.",
      },
      analytics: {
        title: "ანალიტიკა",
        desc: "წარმადობის მეტრიკა და ბიზნეს ინსაითები",
        totalScans: "სულ სკანირებები",
        newMembers: "ახალი წევრები",
        rewardsClaimed: "მოთხოვნილი ჯილდოები",
        avgVisitFreq: "საშ. ვიზიტის სიხშირე",
        last30Days: "ბოლო 30 დღე",
        export: "ექსპორტი",
        scanActivity: "სკანირების აქტივობა",
        last7Days: "ბოლო 7 დღე",
        topPrograms: "საუკეთესო პროგრამები",
        loading: "ანალიტიკა იტვირთება...",
        mon: "ორშ", tue: "სამ", wed: "ოთხ", thu: "ხუთ", fri: "პარ", sat: "შაბ", sun: "კვ",
      },
      settings: {
        title: "პარამეტრები",
        desc: "KIDE პარამეტრების კონფიგურაცია",
        saved: "შენახულია",
        saving: "ინახება...",
        saveChanges: "ცვლილებების შენახვა",
        general: "ზოგადი",
        businessName: "ბიზნესის სახელი",
        timezone: "დროის ზონა",
        notifications: "შეტყობინებები",
        emailAlerts: "ელ-ფოსტის შეტყობინებები",
        emailAlertsDesc: "მიიღეთ სკანირების და ჯილდოების შეტყობინებები",
        pushNotifications: "Push შეტყობინებები",
        pushDesc: "რეალურ დროში შეტყობინებები ბარათის სკანირებისას",
        loading: "პარამეტრები იტვირთება...",
        customerExperience: "მომხმარებლის გამოცდილება",
        defaultLanguage: "ნაგულისხმევი ენა",
        welcomeMessage: "მისასალმებელი შეტყობინება",
        welcomeMessageDesc: "ტექსტი რომელიც მომხმარებელს გამოუჩნდება სკანირებისას",
        welcomeMessagePlaceholder: "მაგ: კეთილი იყოს თქვენი მობრძანება!",
      },
    },
    mnuqrTab: {
      orders: {
        title: "შეკვეთები",
        desc: "თვალყური ადევნეთ და მართეთ შემოსული შეკვეთები რეალურ დროში",
        active: "აქტიური",
        completed: "დასრულებული",
        notifications: "შეტყობინებები",
        pending: "მომლოდინე",
        callServer: "მიმტანის გამოძახება",
        requestBill: "ანგარიშის მოთხოვნა",
        unknownTable: "უცნობი მაგიდა",
        done: "შესრულდა",
        loading: "შეკვეთები იტვირთება...",
        noActive: "აქტიური შეკვეთები არ არის",
        noCompleted: "დასრულებული შეკვეთები არ არის",
        activeEmpty: "შეკვეთები აქ გამოჩნდება რეალურ დროში",
        completedEmpty: "დასრულებული შეკვეთები აქ გამოჩნდება",
        table: "მაგიდა",
        total: "სულ",
        time: "დრო",
        newOrder: "ახალი შეკვეთა",
        preparing: "მზადდება",
        ready: "მზადაა",
        served: "მირთმეულია",
        cancelled: "გაუქმებულია",
        rejected: "უარყოფილია",
        eta: "სავარაუდო დრო",
        rejectOrder: "შეკვეთის უარყოფა",
        rejectReason: "უარყოფის მიზეზი (არასავალდებულო)...",
        cancel: "გაუქმება",
        reject: "უარყოფა",
        acceptOrder: "შეკვეთის მიღება",
        markReady: "მზად მონიშვნა",
        markServed: "მირთმეულად მონიშვნა",
        item: "ნაირსახეობა",
        qty: "რაოდ.",
        price: "ფასი",
        no: "გარეშე:",
        items: "ნაირსახეობა",
        tip: "ჩაი",
        reason: "მიზეზი:",
        printReceipt: "ქვითრის ბეჭდვა",
        order: "შეკვეთა",
        subtotal: "ქვეჯამი",
        thankYou: "მადლობა!",
        resetPinLock: "განახლება და დაბლოკვა",
        resetPinLockTitle: "PIN-ის განახლება და დაბლოკვა",
        resetPinLockConfirm: "ეს შექმნის ახალ PIN-ს და გათიშავს ყველა მომხმარებელს ამ მაგიდაზე. გაგრძელება?",
        sessionsTerminated: "სესია დაბლოკილია",
      },
      editMenus: {
        title: "მენიუს რედაქტირება",
        desc: "მართეთ კატეგორიები, ნაირსახეობები და ინგრედიენტები",
        newCategory: "ახალი კატეგორია",
        categoryName: "კატეგორიის სახელი",
        add: "დამატება",
        loading: "მენიუ იტვირთება...",
        noCategories: "კატეგორიები ჯერ არ არის",
        noCategoriesDesc: "შექმენით პირველი კატეგორია მენიუს აგებისთვის",
        item: "ნაირსახეობა",
        items: "ნაირსახეობა",
        noItems: "ამ კატეგორიაში ნაირსახეობები ჯერ არ არის",
        loadingItems: "ნაირსახეობები იტვირთება...",
        editItem: "ნაირსახეობის რედაქტირება",
        itemName: "სახელი *",
        description: "აღწერა",
        imageUrl: "სურათის URL",
        prepMin: "მომზ. წთ",
        min: "წთ",
        dietaryTags: "დიეტური ტეგები",
        status: "სტატუსი",
        active: "აქტიური",
        inactive: "არააქტიური",
        nameRequired: "სახელი სავალდებულოა",
        invalidPrice: "შეიყვანეთ ვალიდური ფასი",
        failedSave: "შენახვა ვერ მოხერხდა",
        cancel: "გაუქმება",
        saving: "ინახება...",
        saveItem: "ნაირსახეობის შენახვა",
        delete: "წაშლა",
        ingredients: "ინგრედიენტები",
        ingredientName: "ინგრედიენტის სახელი",
        default: "სტანდარტული",
        optional: "არასავალდებულო",
        noIngredients: "ინგრედიენტები ჯერ არ არის",
        addItem: "ნაირსახეობის დამატება",
        adding: "ემატება...",
        descriptionOpt: "აღწერა (არასავალდებულო)",
        imageUrlOpt: "სურათის URL (არასავალდებულო)",
        langEn: "EN",
        langKa: "ქარ",
        nameEn: "სახელი (EN) *",
        nameKa: "სახელი (ქარ)",
        descEn: "აღწერა (EN)",
        descKa: "აღწერა (ქარ)",
        descEnOpt: "აღწერა EN (არასავალდებულო)",
        descKaOpt: "აღწერა ქარ (არასავალდებულო)",
        categoryNameEn: "კატეგორიის სახელი (EN)",
        categoryNameKa: "კატეგორიის სახელი (ქარ)",
        ingredientNameEn: "ინგრედიენტი (EN)",
        ingredientNameKa: "ინგრედიენტი (ქარ)",
        outOfStock: "ამოიწურა",
        inStock: "მარაგშია",
      },
      qrCodes: {
        title: "QR კოდები",
        desc: "მართეთ მაგიდები და გენერირეთ QR კოდები მომხმარებლის შეკვეთებისთვის",
        addTable: "მაგიდის დამატება",
        totalTables: "სულ მაგიდები",
        activeTables: "აქტიური მაგიდები",
        qrGenerated: "QR კოდები გენერირებული",
        number: "#",
        label: "ეტიკეტი",
        qrCode: "QR კოდი",
        status: "სტატუსი",
        actions: "მოქმედებები",
        tableNumber: "მაგიდის ნომერი (მაგ. 1)",
        tableLabel: "ეტიკეტი (მაგ. ფანჯრის ადგილი)",
        cancel: "გაუქმება",
        save: "შენახვა",
        qrReady: "QR მზადაა",
        noQr: "QR არ არის",
        active: "აქტიური",
        inactive: "არააქტიური",
        viewQr: "QR-ის ნახვა",
        generating: "გენერირდება...",
        generateQr: "QR-ის გენერაცია",
        loading: "მაგიდები იტვირთება...",
        noTables: "მაგიდები ჯერ არ არის",
        noTablesDesc: "დაამატეთ პირველი მაგიდა QR კოდების გენერაციისთვის",
        download: "ჩამოტვირთვა",
        print: "ბეჭდვა",
        stickerFooter: "*** თხოვე კოდი მიმტანს",
        stickerDownload: "სტიკერის PNG",
        stickerDownloadPlain: "მარტივი QR (PNG)",
        stickerPrint: "სტიკერის ბეჭდვა",
        stickerHelp: "მაღალი რეზოლუცია (~8″ @300DPI) ბეჭდვისთვის",
        stickerKideMissing: "KIDE მაღაზიის ბმულისთვის შეავსეთ ბიზნესის პროფილი (KIDE ჩანართი).",
      },
      analytics: {
        title: "მენიუს ანალიტიკა",
        desc: "რეალურ დროის წარმადობის მეტრიკა თქვენი რესტორნისთვის",
        exportCsv: "CSV ექსპორტი",
        loading: "ანალიტიკა იტვირთება...",
        totalOrders: "სულ შეკვეთები",
        revenue7d: "შემოსავალი (7დ)",
        avgOrderValue: "საშ. შეკვეთის ღირებულება",
        completionRate: "დასრულების მაჩვენებელი",
        topItem: "ტოპ ნაირსახეობა",
        cancellation: "გაუქმება",
        activeTables: "აქტიური მაგიდები",
        menuItems: "მენიუს ნაირსახეობები",
        tips7d: "ჩაი (7დ)",
        orders: "შეკვეთები",
        pendingLabel: "მომლოდინე",
        categories: "კატეგორიები",
        collected: "შეგროვებული",
        vsPrev7d: "წინა 7დ-თან",
        ordersPerDay: "შეკვეთები დღეში",
        last7Days: "ბოლო 7 დღე",
        revenuePerDay: "შემოსავალი დღეში",
        topMenuItems: "ტოპ მენიუს ნაირსახეობები",
        byOrderCount: "შეკვეთების მიხედვით · ბოლო 7 დღე",
        itemCol: "ნაირსახეობა",
        ordersCol: "შეკვეთები",
        revenueCol: "შემოსავალი",
        noData: "შეკვეთების მონაცემები ჯერ არ არის",
        allTimeOrders: "ყველა დროის შეკვეთები",
        allTimeRevenue: "ყველა დროის შემოსავალი",
        pendingNow: "ახლა მომლოდინე",
        mon: "ორშ", tue: "სამ", wed: "ოთხ", thu: "ხუთ", fri: "პარ", sat: "შაბ", sun: "კვ",
      },
      settings: {
        title: "პარამეტრები",
        desc: "MNU.QR პარამეტრების კონფიგურაცია",
        saved: "შენახულია",
        saveChanges: "ცვლილებების შენახვა",
        general: "ზოგადი",
        businessName: "ბიზნესის სახელი",
        defaultLanguage: "ნაგულისხმევი ენა",
        currency: "ვალუტა",
        autoAcceptOrders: "შეკვეთების ავტომატური მიღება",
        autoAcceptOrdersDesc: "ახალი შეკვეთები ავტომატურად მიიღება დადასტურების გარეშე",
        notifications: "შეტყობინებები",
        callAlerts: "გამოძახების შეტყობინებები",
        callAlertsDesc: "ხმა და შეტყობინება როცა მომხმარებელი ოფიციანტს იძახებს ან ანგარიშს ითხოვს",
        callAlertsSound: "გამოძახების ხმა",
        orderAlerts: "შეკვეთების შეტყობინებები",
        orderAlertsDesc: "ხმა და შეტყობინება ახალი შეკვეთის მიღებისას",
        orderAlertsSound: "შეკვეთის ხმა",
        soundOn: "ჩართული",
        soundOff: "გამორთული",
        security: "უსაფრთხოება",
        loading: "პარამეტრები იტვირთება...",
        search: "ძებნა",
        branchLocations: "ფილიალების მდებარეობა",
        branchLocationsDesc: "დააჭირეთ რუკაზე მდებარეობის დასამატებლად. გაზიარებულია Kide და MNU.QR-ს შორის.",
        addBranch: "დამატება",
        branch: "ფილიალი",
        addressLabel: "მისამართის ეტიკეტი",
        latitude: "განედი",
        longitude: "გრძედი",
        enableOrdering: "შეკვეთების ჩართვა",
        enableOrderingDesc: "გამორთვისას მომხმარებლები მხოლოდ მენიუს ნახავენ შეკვეთის გარეშე.",
      },
      businessInfo: {
        title: "ბიზნეს ინფორმაცია",
        desc: "შეავსეთ თქვენი რესტორნის სახელი და სოციალური ბმულები მენიუს გვერდისთვის",
        saveChanges: "შენახვა",
        saved: "შენახულია",
        saving: "ინახება...",
        restaurantName: "რესტორნის სახელი",
        socialLinks: "სოციალური ბმულები",
        website: "ვებსაიტი",
      },
      minimap: {
        title: "სართულის რუკა",
        desc: "მინიატურული რუკა შეტყობინებებისთვის ეკრანის ქვედა მარცხენა კუთხეში",
        floorMap: "სართულის რუკა",
        editLayout: "მაგიდების განლაგება",
        editLayoutDesc: "გადაიტანეთ მაგიდები სასურველ პოზიციაზე",
        editLayoutSettingsDesc: "მოაწყვეთ მაგიდების პოზიციები რუკაზე",
        editLayoutBtn: "რედაქტირება",
        save: "შენახვა",
        saved: "შენახულია",
        reset: "საწყისი",
        station: "სადგური",
        table: "მაგიდა",
        dragHint: "გადაიტანეთ ელემენტები",
        noTables: "მაგიდები არ არის",
        noTablesDesc: "ჯერ დაამატეთ მაგიდები QR კოდების განყოფილებაში",
        callServer: "მიმტანის გამოძახება",
        requestBill: "ანგარიშის მოთხოვნა",
        newOrder: "ახალი შეკვეთა",
        clickToDismiss: "დააწკაპეთ გასაუქმებლად",
        occupied: "დაკავებული",
        clickToFree: "დააწკაპეთ გასათავისუფლებლად",
        clickToOccupy: "დააწკაპეთ დასაკავებლად",
      },
    },
    imageUpload: {
      uploadMode: "ფაილის ატვირთვა",
      urlMode: "URL ბმული",
      dropOrClick: "აირჩიეთ ფაილი ან ჩააგდეთ აქ",
      urlPlaceholder: "https://example.com/image.jpg",
      uploading: "იტვირთება...",
      remove: "წაშლა",
      invalidType: "მხარდაჭერილი ფორმატები: JPEG, PNG, WebP, GIF",
      fileTooLarge: "ფაილის ზომა არ უნდა აღემატებოდეს 5 MB-ს",
      uploadFailed: "ატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა.",
      serviceUnavailable: "ატვირთვის სერვისი მიუწვდომელია",
      invalidUrl: "URL უნდა იყოს https პროტოკოლით",
      imageLoadFailed: "სურათი ვერ ჩაიტვირთა ამ URL-დან",
    },
  },

  en: {
    header: {
      stations: "PRODUCTS",
      platform: "PLATFORM",
      pricing: "PRICING",
      contact: "CONTACT",
      logIn: "LOG IN",
      getStarted: "GET STARTED",
      dashboard: "Dashboard",
      signOut: "Sign Out",
      wallet: "Wallet",
    },
    hero: {
      badge: "FOR RESTAURANTS, CAFES & HOTELS",
      headline: "Loyalty & Orders.\nOne Dashboard.",
      subtitle:
        "KIDE loyalty programs and MNU.QR digital menus — from a single platform. No app download required.",
      bookDemo: "BOOK A DEMO",
      seeHow: "SEE HOW IT WORKS →",
    },
    businesses: {
      title: "OUR PARTNERS",
      subtitle: "Discover businesses powered by FlowState",
      all: "All",
      coffee: "Coffee",
      food: "Food",
      retail: "Retail",
      wellness: "Wellness",
      services: "Services",
      noBranches: "No branches",
      noBusinesses: "No businesses yet",
      branches: "branch",
      rating: "Rating",
    },
    preview: {
      yourDashboard: "YOUR DASHBOARD",
      live: "LIVE",
      newOrder: "NEW ORDER — TABLE 4",
      placed: "PLACED",
      margherita: "2x Margherita Pizza",
      caesar: "1x Caesar Salad",
      noAnchovies: "NO: Anchovies",
      accept: "ACCEPT",
      reject: "REJECT",
      stampGranted: "Stamp Granted",
      stampInfo: "Maria S. — 7/10 stamps",
      justNow: "Just now",
      cafeName: "Cafe Milano",
      table4: "TABLE 4",
      menu: "MENU",
      margheritaName: "Margherita Pizza",
      vegetarian: "VEGETARIAN",
      caesarName: "Caesar Salad",
      glutenFree: "GLUTEN-FREE",
      yourOrder: "YOUR ORDER",
      preparing: "Preparing your order...",
      callServer: "CALL SERVER",
      requestBill: "REQUEST BILL",
      min15: "15 min",
      min10: "10 min",
    },
    stations: {
      label: "// 001 — PRODUCTS",
      headline: "Two Products.\nEverything You Need.",
      subtitle:
        "Deploy one or both. Each works independently and connects through a shared dashboard.",
      kideSubtitle: "Loyalty & Retention",
      mnuqrSubtitle: "Digital Menus & Ordering",
      kide: {
        scanner: {
          title: "QR Loyalty Scanner",
          desc: "Scan with camera or enter a 6-digit code. Grants stamps, tracks history, enforces cooldowns.",
        },
        programs: {
          title: "Programs & Rewards",
          desc: "Stamp-based loyalty with configurable thresholds. Set up rewards with point costs.",
        },
        analytics: {
          title: "Members & Analytics",
          desc: "Auto-enrollment with unique QR IDs. Retention metrics and CSV export.",
        },
      },
      mnuqr: {
        builder: {
          title: "Menu Builder",
          desc: "Categories, items, pricing, images, dietary tags, and ingredient customization.",
        },
        orders: {
          title: "Order Management",
          desc: "Full lifecycle — Placed, Preparing, Ready, Served. Accept, reject, and print receipts.",
        },
        selfOrder: {
          title: "Guest Self-Ordering",
          desc: "Scan table QR, browse menu, customize, and order from phone. No app needed.",
        },
      },
    },
    features: {
      label: "// 002 — PLATFORM",
      headline: "One Dashboard. Full Control.",
      subtitle:
        "Both products share a unified platform — real-time sync, role-based permissions, and a single view.",
      dashboard: {
        title: "Unified Dashboard",
        desc: "Loyalty and menu orders from a single screen. Switch between products or use split-view.",
      },
      realtime: {
        title: "Real-Time Everything",
        desc: "Orders, loyalty stamps, menu changes, and notifications all sync instantly. Your staff and guests always see the latest data.",
      },
      security: {
        title: "Secure & Role-Based",
        desc: "Role-based access for your team, API keys for integrations, and audit logging for every action. Your data stays under your control.",
      },
    },
    howItWorks: {
      label: "// 003 — HOW IT WORKS",
      headline: "Live in Three Steps",
      step1: {
        title: "Request Access",
        desc: "Tell us about your business and pick — KIDE, MNU.QR, or both.",
      },
      step2: {
        title: "We Set You Up",
        desc: "Our team configures your dashboard, imports your menu or loyalty setup, and generates QR codes.",
      },
      step3: {
        title: "Go Live",
        desc: "Launch and start tracking orders, loyalty, and analytics in real time.",
      },
      requestAccess: "REQUEST ACCESS",
    },
    wallet: {
      title: "Your loyalty wallet",
      subtitle: "See your stamp progress, coupons, and rewards in one place.",
      goToDashboard: "Partner dashboard",
      cards: "Cards",
      cardsCount: "{count} active cards",
      loadingCards: "Loading your cards...",
      noCards: "You don't have any loyalty cards yet.",
      noCardsHint: "Ask the venue about their FlowState loyalty program to get started.",
      stampsLabel: "{current}/{required} stamps",
      tapToOpen: "Open card for details",
      history: "Reward history",
      historyCount: "{count} entries",
      loadingHistory: "Loading history...",
      noHistoryYet: "You haven't claimed any rewards yet.",
      noDataYet: "Your wallet is empty. Collect stamps to unlock your first reward.",
      noHistoryHint: "When you claim rewards, their codes and status will appear here.",
      codeLabel: "Code:",
      statusRedeemed: "REDEEMED",
      statusPending: "PENDING",
      statusExpired: "EXPIRED",
      backToDashboard: "Back to dashboard",
      rewardAvailable: "Reward available",
      loadingCard: "Loading your card...",
      cardStamps: "{current}/{required} stamps in this program",
      presentAtCounter: "Show this QR or code at the counter",
      expiresIn: "Expires in {seconds}s",
      generatingCode: "Generating code...",
      generateCode: "Generate code",
      refreshCode: "Refresh code",
      orShareCode: "Or share the 6-digit code",
      back: "Back to wallet",
      rewards: "Rewards",
      noRewardsConfigured: "This venue hasn't configured rewards yet.",
      claimReward: "Claim reward",
      notEnoughStamps: "Not enough stamps",
      claimSuccess: "Reward \"{reward}\" is ready to redeem.",
      showCode: "Show this code to staff to redeem your reward.",
      pendingRewards: "Unredeemed rewards",
      pendingRewardsHint: "These rewards haven't been redeemed yet. Show the code to staff.",
      pendingStatus: "Pending — not yet redeemed",
      viewCode: "View code",
      hideCode: "Hide code",
      tapToViewReward: "Tap to view reward code →",
      cancelCard: "CANCEL CARD",
      cancelCardConfirmTitle: "Cancel this stamp card?",
      cancelCardConfirmDesc: "All stamps and progress will be permanently deleted. This action cannot be undone.",
      cancelCardNo: "NO",
      cancelCardYes: "CANCEL",
    },
    why: {
      label: "// 004 — WHY FlowState",
      headline: "Built Different. On Purpose.",
      reasons: {
        vendors: {
          title: "Replace Multiple Vendors",
          desc: "Loyalty, menus, ordering, QR codes, and analytics in one platform — not separate tools.",
        },
        noApp: {
          title: "No App Download",
          desc: "Customers scan a QR code and they're in — from their phone's browser.",
        },
        hospitality: {
          title: "Built for Hospitality",
          desc: "Every feature is designed for restaurants, cafes, and hotels.",
        },
        fast: {
          title: "Launch in Days",
          desc: "We handle setup and onboarding. Your business goes live with minimal effort.",
        },
      },
    },
    pricing: {
      label: "// 005 — PRICING",
      headline: "Simple, Transparent Pricing",
      subtitle:
        "Every plan includes setup, onboarding, and support. Deploy one product or both.",
      monthly: "MONTHLY",
      yearly: "YEARLY",
      save20: "SAVE 20%",
      perMonth: "/mo",
      billedAnnually: "billed annually",
      bestValue: "BEST VALUE",
      contactSales: "CONTACT SALES",
      kide: {
        desc: "Loyalty & retention product",
        features: [
          "Unlimited loyalty programs",
          "QR scanner + manual code entry",
          "Configurable stamps & rewards",
          "Member management & analytics",
          "Business profile & multi-branch",
          "CSV export & API access",
        ],
      },
      mnuqr: {
        desc: "Digital menus & ordering product",
        features: [
          "Menu builder with dietary tags",
          "Real-time order management",
          "Table QR codes (print & download)",
          "Guest self-ordering (no app)",
          "Server & bill notifications",
          "Revenue analytics & CSV export",
        ],
      },
      fullSuite: {
        name: "FULL SUITE",
        desc: "Both products + priority support",
        features: [
          "Everything in KIDE + MNU.QR",
          "Unified dashboard with split-view",
          "Dedicated account manager",
          "Priority support",
          "Custom integrations",
          "Early access to new features",
        ],
      },
      cta: {
        headline: "Ready to Get Started?",
        subtitle:
          "Book a demo and we'll walk you through exactly how FlowState works for your venue.",
        bookDemo: "BOOK A DEMO",
        requestAccess: "REQUEST ACCESS →",
      },
    },
    footer: {
      desc: "Loyalty programs, digital menus, real-time ordering, and analytics — from one platform.",
      stations: "PRODUCTS",
      kideLoyalty: "KIDE — Loyalty",
      mnuqrMenus: "MNU.QR — Menus",
      fullSuite: "Full Suite",
      pricingLink: "Pricing",
      platformCol: "PLATFORM",
      commandStation: "Dashboard",
      howItWorks: "How It Works",
      requestAccess: "Request Access",
      bookDemo: "Book a Demo",
      company: "COMPANY",
      contactSales: "Contact Sales",
      aboutUs: "About Us",
      careers: "Careers",
      blog: "Blog",
      rights: "© 2026 FlowState. ALL RIGHTS RESERVED.",
      privacy: "PRIVACY",
      terms: "TERMS",
      security: "SECURITY",
    },
    login: {
      commandCenter: "Your Business\nCommand Center",
      subtitle: "Loyalty programs, digital menus, and operations management — all from one unified platform.",
      signIn: "SIGN IN",
      welcome: "Welcome back. Enter your credentials to continue.",
      email: "EMAIL",
      password: "PASSWORD",
      pleaseWait: "PLEASE WAIT...",
      invalidCredentials: "Invalid email or password.",
      timedOut: "Sign in timed out. Please try again.",
      wantPartner: "Want to become a partner?",
      requestAccessDesc: "Request access and our team will set you up",
      requestPartnerAccess: "REQUEST PARTNER ACCESS",
      accountSuspended: "ACCOUNT SUSPENDED",
      suspendedMsg: "Your account has been suspended. Please contact your administrator for more information.",
      backToSignIn: "BACK TO SIGN IN",
    },
    requestAccess: {
      headline: "Join Leading\nBusinesses",
      subtitle: "Request partner access to deploy FlowState's modular platform — loyalty, menus, and operations, all managed by our team.",
      title: "REQUEST ACCESS",
      plan: "PLAN",
      formSubtitle: "Fill in your details and our team will get back to you within 48 hours.",
      fullName: "FULL NAME",
      workEmail: "WORK EMAIL",
      companyName: "COMPANY NAME",
      yourRole: "YOUR ROLE",
      contactNumber: "CONTACT NUMBER",
      tellUs: "TELL US ABOUT YOUR NEEDS",
      tellUsPlaceholder: "What products are you interested in? Any specific requirements?",
      submitting: "SUBMITTING...",
      submitRequest: "SUBMIT REQUEST",
      alreadyHaveAccount: "Already have an account?",
      signInLink: "Sign In",
      submitted: "REQUEST SUBMITTED",
      submittedMsg: "We'll review your request and get back to you within 48 hours.",
      backHome: "BACK TO HOME",
      avgResponse: "AVG. RESPONSE",
      onboarding: "ONBOARDING",
      free: "Free",
      support: "SUPPORT",
    },
    contactSales: {
      backHome: "← BACK TO HOME",
      headline: "Contact Sales",
      subtitle: "Talk to our sales team about the Full Suite plan and custom integrations tailored to your business.",
      yourName: "Your Name",
      workEmail: "Work Email",
      companyName: "Company Name",
      tellUs: "Tell us about your needs...",
      sendMessage: "SEND MESSAGE",
    },
    dash: {
      splitView: "SPLIT VIEW",
      exitSplit: "EXIT SPLIT VIEW",
      noActiveServices: "NO ACTIVE SERVICES",
      noServicesMsg: "No active services available. Please contact your administrator.",
      noServices: "NO SERVICES",
      kideNav: {
        scanStamps: "SCAN STAMPS",
        businessInfo: "BUSINESS INFO",
        loyalty: "LOYALTY PROGRAM",
        users: "USERS",
        analytics: "ANALYTICS",
        settings: "SETTINGS",
      },
      mnuqrNav: {
        ringServer: "RING SERVER",
        orders: "ORDERS",
        editMenus: "EDIT MENUS",
        qrCodes: "QR CODES",
        menuAnalytics: "MENU ANALYTICS",
        settings: "SETTINGS",
        businessInfo: "BUSINESS INFO",
      },
      kideLabel: "KIDE",
      mnuqrLabel: "MNU.QR",
    },
    kideTab: {
      scanStamps: {
        title: "SCAN STAMPS",
        desc: "Scan customer QR codes to grant loyalty stamps",
        scanner: "SCANNER",
        cameraUnavailable: "Camera unavailable",
        retry: "RETRY",
        enterCode: "OR ENTER CODE",
        grant: "GRANT",
        stampsGranted: "STAMPS GRANTED",
        errors: "ERRORS",
        totalScans: "TOTAL SCANS",
        lastScan: "LAST SCAN",
        latestActivity: "LATEST ACTIVITY",
        clear: "CLEAR",
        status: "STATUS",
        details: "DETAILS",
        time: "TIME",
        noScansYet: "No scans yet. Point camera at a QR code or enter a code above.",
        cooldown: "Cooldown",
        minRemaining: "min remaining",
        failedGrant: "Failed to grant stamp",
        codeExpired: "Code has expired",
        codeAlreadyUsed: "Code has already been used",
        wrongPartner: "Code belongs to another partner",
        codeNotFound: "Code not found",
        stampGrantedPopup: "Stamp Granted",
        rewardRedeemedPopup: "Reward Redeemed",
        userNotFound: "User not found for code",
        stamps: "Stamps",
        untilReward: "until reward",
      },
      businessInfo: {
        title: "BUSINESS INFO",
        desc: "Manage your business profile displayed to customers",
        loading: "Loading business info...",
        saved: "SAVED",
        saving: "SAVING...",
        saveChanges: "SAVE CHANGES",
        failedSave: "Failed to save. Please try again.",
        basicInfo: "BASIC INFORMATION",
        businessName: "BUSINESS NAME",
        businessNamePlaceholder: "Enter business name",
        googleRating: "GOOGLE RATING",
        googleRatingPlaceholder: "0 - 5",
        coverImagePlaceholder: "https://example.com/image.jpg",
        phonePlaceholder: "+1 234 567 890",
        websitePlaceholder: "https://example.com",
        about: "ABOUT",
        aboutPlaceholder: "Tell customers about your business",
        coverImage: "COVER IMAGE URL",
        phone: "PHONE NUMBER",
        website: "WEBSITE URL",
        branches: "BRANCH LOCATIONS",
        addBranch: "ADD BRANCH",
        noBranches: "No branches added yet. Click \"Add Branch\" to add one.",
        branch: "BRANCH",
        addressLabel: "Address label",
        latitude: "Latitude",
        longitude: "Longitude",
        openingHours: "OPENING HOURS",
        to: "to",
        closed: "Closed",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        category: "CATEGORY",
        selectCategory: "Select a category",
        cat_coffee: "Coffee",
        cat_food: "Food",
        cat_retail: "Retail",
        cat_wellness: "Wellness",
        cat_services: "Services",
        clickMapToAdd: "Click on the map to add a branch location",
      },
      loyalty: {
        title: "LOYALTY PROGRAMS",
        desc: "Manage, edit, and track your loyalty programs",
        search: "SEARCH",
        newProgram: "NEW PROGRAM",
        members: "MEMBERS",
        rewards: "REWARDS",
        conversion: "CONVERSION",
        loading: "Loading...",
        noPrograms: "No loyalty programs yet. Create your first one.",
        programStats: "PROGRAM STATS",
        totalMembers: "TOTAL MEMBERS",
        rewardsGiven: "REWARDS GIVEN",
        conversionRate: "CONVERSION RATE",
        status: "STATUS",
        editProgram: "EDIT PROGRAM",
        maxUsers: "MAX USERS",
        unlimited: "Unlimited",
        leaveEmpty: "Leave empty for unlimited",
        stampsRequired: "STAMPS REQUIRED",
        stampsMin: "Stamps required must be at least 1",
        scanCooldown: "SCAN COOLDOWN (MIN)",
        cooldownRange: "Cooldown must be between 1 and 1440 minutes",
        saving: "SAVING...",
        saveChanges: "SAVE CHANGES",
        changesSaved: "Changes saved successfully",
        programName: "PROGRAM NAME",
        reward: "REWARD",
        rewardPlaceholder: "e.g. Free coffee",
        rewardRequired: "Reward description is required",
        new: "New",
        active: "ACTIVE",
        popular: "POPULAR",
        paused: "PAUSED",
        createProgram: "CREATE PROGRAM",
      },
      users: {
        title: "USERS",
        desc: "View enrolled loyalty program members",
        search: "SEARCH USERS",
        allUsers: "ALL USERS",
        total: "total",
        name: "NAME",
        email: "EMAIL",
        stamps: "STAMPS",
        enrolled: "ENROLLED",
        loading: "Loading...",
        noUsers: "No users enrolled yet.",
      },
      analytics: {
        title: "ANALYTICS",
        desc: "Performance metrics and business insights",
        totalScans: "TOTAL SCANS",
        newMembers: "NEW MEMBERS",
        rewardsClaimed: "REWARDS CLAIMED",
        avgVisitFreq: "AVG VISIT FREQ",
        last30Days: "LAST 30 DAYS",
        export: "EXPORT",
        scanActivity: "SCAN ACTIVITY",
        last7Days: "LAST 7 DAYS",
        topPrograms: "TOP PROGRAMS",
        loading: "Loading analytics...",
        mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun",
      },
      settings: {
        title: "SETTINGS",
        desc: "Configure your KIDE preferences",
        saved: "SAVED",
        saving: "SAVING...",
        saveChanges: "SAVE CHANGES",
        general: "GENERAL",
        businessName: "BUSINESS NAME",
        timezone: "TIMEZONE",
        notifications: "NOTIFICATIONS",
        emailAlerts: "Email Alerts",
        emailAlertsDesc: "Receive scan and reward notifications",
        pushNotifications: "Push Notifications",
        pushDesc: "Real-time alerts for card scans",
        loading: "Loading settings...",
        customerExperience: "CUSTOMER EXPERIENCE",
        defaultLanguage: "DEFAULT LANGUAGE",
        welcomeMessage: "WELCOME MESSAGE",
        welcomeMessageDesc: "Text shown to customers when they scan",
        welcomeMessagePlaceholder: "e.g. Welcome to our store!",
      },
    },
    mnuqrTab: {
      orders: {
        title: "ORDERS",
        desc: "Track and manage incoming orders in real-time",
        active: "ACTIVE",
        completed: "COMPLETED",
        notifications: "NOTIFICATIONS",
        pending: "PENDING",
        callServer: "CALL SERVER",
        requestBill: "REQUEST BILL",
        unknownTable: "Unknown Table",
        done: "DONE",
        loading: "Loading orders...",
        noActive: "NO ACTIVE ORDERS",
        noCompleted: "NO COMPLETED ORDERS",
        activeEmpty: "Orders will appear here in real-time",
        completedEmpty: "Completed orders will show here",
        table: "TABLE",
        total: "TOTAL",
        time: "TIME",
        newOrder: "NEW ORDER",
        preparing: "PREPARING",
        ready: "READY",
        served: "SERVED",
        cancelled: "CANCELLED",
        rejected: "REJECTED",
        eta: "ETA",
        rejectOrder: "Reject Order",
        rejectReason: "Reason for rejection (optional)...",
        cancel: "CANCEL",
        reject: "REJECT",
        acceptOrder: "ACCEPT ORDER",
        markReady: "MARK READY",
        markServed: "MARK SERVED",
        item: "ITEM",
        qty: "QTY",
        price: "PRICE",
        no: "NO:",
        items: "items",
        tip: "tip",
        reason: "Reason:",
        printReceipt: "Print receipt",
        order: "ORDER",
        subtotal: "Subtotal",
        thankYou: "Thank you!",
        resetPinLock: "RESET & LOCK",
        resetPinLockTitle: "Reset PIN & Lock Out",
        resetPinLockConfirm: "This will generate a new PIN and disconnect all customers at this table. Continue?",
        sessionsTerminated: "sessions locked out",
      },
      editMenus: {
        title: "EDIT MENUS",
        desc: "Manage categories, items, and ingredients",
        newCategory: "NEW CATEGORY",
        categoryName: "Category name",
        add: "ADD",
        loading: "Loading menu...",
        noCategories: "NO CATEGORIES YET",
        noCategoriesDesc: "Create your first category to start building your menu",
        item: "ITEM",
        items: "items",
        noItems: "No items in this category yet",
        loadingItems: "Loading items...",
        editItem: "EDIT ITEM",
        itemName: "Item name *",
        description: "Description",
        imageUrl: "Image URL",
        prepMin: "Prep min",
        min: "min",
        dietaryTags: "DIETARY TAGS",
        status: "STATUS",
        active: "ACTIVE",
        inactive: "INACTIVE",
        nameRequired: "Name is required",
        invalidPrice: "Enter a valid price",
        failedSave: "Failed to save",
        cancel: "CANCEL",
        saving: "SAVING...",
        saveItem: "SAVE ITEM",
        delete: "DELETE",
        ingredients: "INGREDIENTS",
        ingredientName: "Ingredient name",
        default: "DEFAULT",
        optional: "OPTIONAL",
        noIngredients: "No ingredients yet",
        addItem: "ADD ITEM",
        adding: "ADDING...",
        descriptionOpt: "Description (optional)",
        imageUrlOpt: "Image URL (optional)",
        langEn: "EN",
        langKa: "ქარ",
        nameEn: "Name (EN) *",
        nameKa: "Name (KA)",
        descEn: "Description (EN)",
        descKa: "Description (KA)",
        descEnOpt: "Description EN (optional)",
        descKaOpt: "Description KA (optional)",
        categoryNameEn: "Category name (EN)",
        categoryNameKa: "Category name (KA)",
        ingredientNameEn: "Ingredient (EN)",
        ingredientNameKa: "Ingredient (KA)",
        outOfStock: "OUT OF STOCK",
        inStock: "IN STOCK",
      },
      qrCodes: {
        title: "QR CODES",
        desc: "Manage tables and generate QR codes for customer ordering",
        addTable: "ADD TABLE",
        totalTables: "TOTAL TABLES",
        activeTables: "ACTIVE TABLES",
        qrGenerated: "QR CODES GENERATED",
        number: "#",
        label: "LABEL",
        qrCode: "QR CODE",
        status: "STATUS",
        actions: "ACTIONS",
        tableNumber: "Table number (e.g. 1)",
        tableLabel: "Label (e.g. Window Seat)",
        cancel: "CANCEL",
        save: "SAVE",
        qrReady: "QR READY",
        noQr: "NO QR",
        active: "ACTIVE",
        inactive: "INACTIVE",
        viewQr: "VIEW QR",
        generating: "GENERATING...",
        generateQr: "GENERATE QR",
        loading: "Loading tables...",
        noTables: "NO TABLES YET",
        noTablesDesc: "Add your first table to start generating QR codes",
        download: "DOWNLOAD",
        print: "PRINT",
        stickerFooter: "*** Ask your server for the code",
        stickerDownload: "STICKER PNG",
        stickerDownloadPlain: "PLAIN QR (PNG)",
        stickerPrint: "PRINT STICKER",
        stickerHelp: "High resolution (~8″ at 300 DPI) for professional stickers",
        stickerKideMissing: "Complete your KIDE business profile to include the store QR on dual stickers.",
      },
      analytics: {
        title: "MENU ANALYTICS",
        desc: "Real-time performance metrics for your restaurant",
        exportCsv: "EXPORT CSV",
        loading: "Loading analytics...",
        totalOrders: "TOTAL ORDERS",
        revenue7d: "REVENUE (7D)",
        avgOrderValue: "AVG ORDER VALUE",
        completionRate: "COMPLETION RATE",
        topItem: "TOP ITEM",
        cancellation: "CANCELLATION",
        activeTables: "ACTIVE TABLES",
        menuItems: "MENU ITEMS",
        tips7d: "TIPS (7D)",
        orders: "orders",
        pendingLabel: "pending",
        categories: "categories",
        collected: "collected",
        vsPrev7d: "vs prev 7d",
        ordersPerDay: "ORDERS PER DAY",
        last7Days: "LAST 7 DAYS",
        revenuePerDay: "REVENUE PER DAY",
        topMenuItems: "TOP MENU ITEMS",
        byOrderCount: "BY ORDER COUNT · LAST 7 DAYS",
        itemCol: "ITEM",
        ordersCol: "ORDERS",
        revenueCol: "REVENUE",
        noData: "No order data yet",
        allTimeOrders: "ALL-TIME ORDERS",
        allTimeRevenue: "ALL-TIME REVENUE",
        pendingNow: "PENDING NOW",
        mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun",
      },
      settings: {
        title: "SETTINGS",
        desc: "Configure your MNU.QR preferences",
        saved: "SAVED",
        saveChanges: "SAVE CHANGES",
        general: "GENERAL",
        businessName: "BUSINESS NAME",
        defaultLanguage: "DEFAULT LANGUAGE",
        currency: "CURRENCY",
        autoAcceptOrders: "Auto-Accept Orders",
        autoAcceptOrdersDesc: "New orders are automatically accepted without manual confirmation",
        notifications: "NOTIFICATIONS",
        callAlerts: "Call Alerts",
        callAlertsDesc: "Sound and notification when a customer calls a server or requests the bill",
        callAlertsSound: "Call Sound",
        orderAlerts: "Order Alerts",
        orderAlertsDesc: "Sound and notification when a new order is placed",
        orderAlertsSound: "Order Sound",
        soundOn: "On",
        soundOff: "Off",
        security: "SECURITY",
        loading: "Loading settings...",
        search: "SEARCH",
        branchLocations: "Branch Locations",
        branchLocationsDesc: "Click the map to add a location pin. Shared across Kide & MNU.QR.",
        addBranch: "ADD",
        branch: "BRANCH",
        addressLabel: "Address label",
        latitude: "Latitude",
        longitude: "Longitude",
        enableOrdering: "Enable Ordering",
        enableOrderingDesc: "When off, customers can only view the menu without placing orders.",
      },
      businessInfo: {
        title: "BUSINESS INFO",
        desc: "Set your restaurant name and social links for the menu page",
        saveChanges: "SAVE",
        saved: "SAVED",
        saving: "SAVING...",
        restaurantName: "RESTAURANT NAME",
        socialLinks: "SOCIAL LINKS",
        website: "WEBSITE",
      },
      minimap: {
        title: "FLOOR MAP",
        desc: "Minimap notification overlay in the bottom-left corner of the dashboard",
        floorMap: "FLOOR MAP",
        editLayout: "TABLE LAYOUT",
        editLayoutDesc: "Drag tables to match your restaurant floor plan",
        editLayoutSettingsDesc: "Arrange table positions on the floor map",
        editLayoutBtn: "EDIT LAYOUT",
        save: "SAVE",
        saved: "SAVED",
        reset: "RESET",
        station: "Station",
        table: "Table",
        dragHint: "Drag elements to position",
        noTables: "No tables yet",
        noTablesDesc: "Add tables in the QR Codes section first",
        callServer: "Call Server",
        requestBill: "Request Bill",
        newOrder: "New Order",
        clickToDismiss: "Click to dismiss",
        occupied: "Occupied",
        clickToFree: "Click to mark as free",
        clickToOccupy: "Click to mark as occupied",
      },
    },
    imageUpload: {
      uploadMode: "File Upload",
      urlMode: "URL Link",
      dropOrClick: "Choose a file or drop it here",
      urlPlaceholder: "https://example.com/image.jpg",
      uploading: "Uploading...",
      remove: "Remove",
      invalidType: "Supported formats: JPEG, PNG, WebP, GIF",
      fileTooLarge: "File size must not exceed 5 MB",
      uploadFailed: "Upload failed. Please try again.",
      serviceUnavailable: "Upload service is unavailable",
      invalidUrl: "URL must use https protocol",
      imageLoadFailed: "Could not load image from this URL",
    },
  },
} as const;
